<mat-card class="content-global-container">
  <div fxLayout="row" fxLayoutAlign="start stretch" fxFill>
    <div fxFlex="grow" fxLayoutAlign="center center">
      <div fxLayoutAlign="center center">
        <mat-spinner [diameter]="50"></mat-spinner>
      </div>
    </div>
  </div>
</mat-card>
